import React from 'react'
import { Link } from 'gatsby'
import github from '../img/github-icon.svg'
import logo from '../img/logo.png'
import news from '../img/news.svg'
import clapper from '../img/clapper.svg'
import insta from '../img/instagram.svg'
import promo from '../img/phone.svg'
import video from '../img/video.svg'
import takmicenje from '../img/takmicenje.svg'

const Navbar = () => (
    <>
      <nav className="navbar-main mobile">
            <Link to="/" className="navbar-item" activeClassName="active-navbar-item">
              <figure className="image">
                <img src={news} className="navbar-image" alt="Vijesti" />
              </figure>
            </Link>
            <Link to="/predstavljamo" className="navbar-item" activeClassName="active-navbar-item">
              <figure className="image">
                <img src={clapper} className="navbar-image" alt="Promo" />
              </figure>
            </Link>
            <Link to="/takmicenje" className="navbar-item" activeClassName="active-navbar-item">
              <figure className="image">
                <img src={takmicenje} className="navbar-image" alt="Nagradna igra" />
              </figure>
            </Link>
            <Link to="/instagram" className="navbar-item" activeClassName="active-navbar-item">
              <figure className="image">
                <img src={insta} className="navbar-image" alt="Instagram feed" />
              </figure>
            </Link>
            <Link to="/stream" className="navbar-item" activeClassName="active-navbar-item">
              <figure className="image">
                <img src={video} className="navbar-image" alt="BHT stream" />
              </figure>
            </Link>
      </nav>
    </>
)

export default Navbar